import { Calculator, Zap, Layers } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const SourceCell = ({ source, type }) => {
  if (source === "nxmap") {
    return (
      <Badge variant="secondary" className="text-xs gap-1">
        <Zap size={10} />
        NXMap
      </Badge>
    );
  }
  if (source === "computed" || type === "sub_entry_aggregate") {
    return (
      <Badge variant="secondary" className="text-xs gap-1">
        <Calculator size={10} />
        Computed
      </Badge>
    );
  }
  if (source === "mixed") {
    return (
      <Badge variant="outline" className="text-xs gap-1">
        <Layers size={10} />
        Mixed
      </Badge>
    );
  }
  if (source === "manual") {
    return (
      <Badge variant="outline" className="text-xs">
        Manual
      </Badge>
    );
  }
  return <span className="text-muted-foreground text-xs">—</span>;
};

export default SourceCell;
